import type { TypographyVariantsOptions } from '@mui/material/styles';

/**
 * Shared MUI typography variant options (weights, line heights, etc.).
 * fontFamily is resolved per whitelabel/variant in createAppTheme.
 */
export const SHARED_TYPOGRAPHY_VARIANT_OPTIONS: Omit<TypographyVariantsOptions, 'fontFamily'> = {
  h1: {
    fontSize: '40px',
    lineHeight: '48px',
  },
  h2: {
    fontSize: '36px',
    lineHeight: '44px',
  },
  h3: {
    fontSize: '32px',
    lineHeight: '40px',
  },
  h4: {
    fontSize: '28px',
    lineHeight: '36px',
  },
  h5: {
    fontSize: '24px',
    lineHeight: '32px',
  },
  h6: {
    fontSize: '20px',
    lineHeight: '28px',
  },
  subtitle1: {
    fontSize: '18px',
    lineHeight: '26px',
  },
  subtitle2: {
    fontSize: '16px',
    lineHeight: '24px',
  },
  body1: {
    fontSize: '16px',
    lineHeight: '24px',
  },
  body2: {
    fontSize: '14px',
    lineHeight: '20px',
  },
  caption: {
    fontSize: '12px',
    lineHeight: '14px',
  },
  button: {
    textTransform: 'none',
    lineHeight: 1.714,
  },
  overline: {
    fontSize: '10px',
    lineHeight: '12px',
    letterSpacing: '4%',
  },
};
